/**
* @Author: Daniel Rhees <Daniel>
* @Date:   2017-02-07T11:35:36-08:00
* @Email:  daniel@reflexmedia.com
* @Last modified by:   Daniel
* @Last modified time: 2017-03-21T11:36:15-07:00
*/


import React from 'react';
import { StyleSheet, css } from 'aphrodite/no-important';
import { dimensions, spacing, color, textColor, borders } from '../../style';

const style = StyleSheet.create({
  button: {
    display: 'table-cell',
    textAlign: 'center',
    padding: '4px',
    cursor: 'pointer',
    border: borders.DEFAULT,
    borderRightWidth: '0',
    padding: `0 ${spacing.PADDING_MD.padding}`,

    [':first-child']: {
      borderTopLeftRadius: '3px',
      borderBottomLeftRadius: '3px'
    },

    [':last-child']: {
      borderTopRightRadius: '3px',
      borderBottomRightRadius: '3px',
      borderRightWidth: '1px',
    }
  },

  buttonContainer: {
    height: '36px',
    display: 'table-cell',
    verticalAlign: 'middle'
  },

  isSelected: {
    backgroundColor: color.BRAND_1,
    borderColor: color.BRAND_1,
    color: '#fff'
  },

  input: {

  }
});

const RadioButton = (props) => {
  const {
    onChange,
    disabled,
    value,
    checked,
    children,
    ...rest
  } = props

  return (
    <label className={css(style.button, checked && style.isSelected)}>
      <input style={{display: 'none'}}
        type='radio'
        onChange={props.onChange}
        disabled={props.disabled}
        value={value}
        checked={checked}
        {...rest}
      />
      <div className={css(style.buttonContainer)}>
        {props.children}
      </div>
    </label>
  )
};

RadioButton.propTypes = {
  // children: React.PropTypes.node.isRequired,
  onChange: React.PropTypes.func,
};

export default RadioButton;



// WEBPACK FOOTER //
// ./src/components/common/RadioButton.jsx